export enum UserRole {
  User = 'user',
  Admin = 'admin',
}

export enum ApiEndpoint {
  Auth = 'auth-management',
  RefreshTokens = 'refresh-tokens',
  Users = 'users',
  Me = 'me',
  Certificates = 'certificates',
  CertificatesSectionsTemplates = 'certificates-sections-templates ',
  CertificatesPreview = 'certificates-preview',
  CertificatesMint = 'certificates-mint',
  CertificatesRelease = 'certificates-release',
  CertificatesListsUnits = 'certificates-lists-units',
  CertificatesParse = 'certificates-parse',
  Editions = 'editions',
  Credits = 'credits',
  Notifications = 'notifications',
  CertificateConfiguration = 'profiles',
  Media = 'images', // TODO: 'media'
  Settings = 'settings',
  TermsAgreed = 'terms-agreed',
  CertificatesHistory = 'certificates-history',
  CertificateDrafts = 'certificate-drafts',
  GuestCertificates = 'guest-certificates',
  Products = 'products',
  Tags = 'tags-verify',
  AccountReactivation = 'reactivate',
  Whitelist = 'whitelist',
  Company = 'company',
  Facilities = 'facilities',
}

export enum AppSettingKey {
  MintPrice = 'mintPrice',
  ReleasePrice = 'releasePrice',
  CreditPrice = 'creditPrice',
  CurrencyCode = 'currencyCode',
}

export enum CertificateStatus {
  Created = 'created',
  Minted = 'minted',
  Released = 'released',
  Claimed = 'claimed',
}

export enum CertificateKeyMetricType {
  Circle = 'circle',
  Digit = 'digit',
}

export enum LingAttributeType {
  URL = 'url',
  Text = 'text',
  ShortText = 'short-text', // legacy
  File = 'file',
}

export enum LingAttributeIconKey {
  Youtube = 'youtube',
  Facebook = 'facebook',
  Instagram = 'instagram',
  LinkedIn = 'linkedIn',
  File = 'file',
  URL = 'url',
  Code = 'code',
  Text = 'text',
}

export enum FileOperations {
  Add,
  Delete,
}

export enum MediaType {
  Image = 'image',
  Video = 'video',
}

export enum SnackbarMessageType {
  Success = 'success',
  Warn = 'warn',
  Error = 'error',
}

export enum LocalStorageKey {
  NextLocation = 'nextLocation',
  RefreshToken = 'feathers-refresh-jwt',
  AccessToken = 'feathers-jwt',
  UserId = 'userId',
  MutedOnboardingTours = 'mutedOnboardingTours',
  PendingTagScans = 'pendingTagScans',
  PendingTagId = 'pendingTagId',
}

export enum CertListItemAction {
  Mint = 'mint',
  Clone = 'clone',
  Release = 'release',
  CancelRelease = 'cancel-release',
  Delete = 'delete',
  Send = 'send',
  ViewEdition = 'view-edition',
}

export enum CertListSort {
  NewestFirst = 'newest-first',
  NewestLast = 'newest-last',
  UpdatedFirst = 'updated-first',
  UpdatedLast = 'updated-last',
  TaggedFirst = 'tagged-first',
  TaggedLast = 'tagged-last',
  'A-Z' = 'a-z',
  'Z-A' = 'z-a',
}

export enum CertificateDynamicSectionContentType {
  SimpleText = 'simpleText',
  Markdown = 'markdown',
  ProgressBar = 'progressBar',
  SimpleList = 'simpleList',
  ComplexList = 'complexList',
}

export enum QueryParamsKeys {
  Initialization = 'initialization',
  NextNavigation = 'next',
  UnverifiedLogin = 'unverified',
  ImportPublicFormsState = 'importPublicFormsState',
  VerificationToken = 'token',
  PasswordReset = 'reset',
  Edition = 'edition',
  Email = 'email',
}

export enum CertificateTransferOperation {
  Minted = 'mint',
  Send = 'send',
  Claimed = 'claim',
}

export enum OnboardingTourName {
  CreateCertificate = 'create-certificate',
  ReleaseCertificate = 'release-certificate',
  CreateEdition = 'create-edition',
  CertificatesList = 'certificates-list',
}

export enum VideoMimeType {
  MP4 = 'video/mp4',
  MOV = 'video/quicktime',
  AVI = 'video/x-msvideo',
  FLV = 'video/x-flv',
  MKV = 'video/x-matroska',
}

export enum DocumentMimeType {
  PDF = 'application/pdf',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
}

export enum ImageMimeType {
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  SVG = 'image/svg+xml',
}

export type LingMediaMimeType = VideoMimeType | ImageMimeType;
export type LingMimeType = VideoMimeType | DocumentMimeType | ImageMimeType;
export const LingMimeTypeDisplayedExtensions: Record<LingMimeType, string[]> = {
  [VideoMimeType.MP4]: ['mp4'],
  [VideoMimeType.FLV]: ['flv'],
  [VideoMimeType.MKV]: ['mkv'],
  [VideoMimeType.AVI]: ['avi'],
  [VideoMimeType.MOV]: ['mov'],
  [DocumentMimeType.PDF]: ['pdf'],
  [DocumentMimeType.XLSX]: ['xlsx'],
  [DocumentMimeType.CSV]: ['csv'],
  [ImageMimeType.JPEG]: ['jpeg'],
  [ImageMimeType.PNG]: ['png'],
  [ImageMimeType.SVG]: ['svg'],
};

export function getDisplayedExtensions(type: LingMimeType) {
  return LingMimeTypeDisplayedExtensions[type];
}
